(function() {
    'use strict';
a3_cabin_reports.factory('SaAssessmentSyncResultFactory', SaAssessmentSyncResultFactory);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name SaAssessmentSyncResultFactory
    * @description 
    *   Add, Update, Delete and Get Cabin Crew Feedback Sync Results.
    * @ngInject
    */
function SaAssessmentSyncResultFactory(GenericService) {

        /**
        * Initialize the CrewAssessment
        * @memberof SaAssessmentSyncResultFactory
        */
		function SaAssessmentSyncResult() {
			this.Route = null;
			this.DutyDate = null;
			this.message = null;
			this.success = null;
		}

		var objType = 'saAssessmentSyncResults';
		var objCallback = SaAssessmentSyncResult;  
		
		var service = {
			getAssessmentSyncResultsFromStorage: getAssessmentSyncResultsFromStorage,
			setAssessmentSyncResultsToStorage : setAssessmentSyncResultsToStorage,
			getSuccesses : getSuccesses,
			getFailures : getFailures
		}

         /**
         * Get Assessment Sync Results
         * @memberof SaAssessmentSyncResultFactory
         * @returns {Array} SA AssessmentSyncResults 
         */
		function getAssessmentSyncResultsFromStorage() {
			return GenericService.list(objType,objCallback);
		}

        /**
         * Save Assessment Sync Results in Local Storage
         * @memberof SaAssessmentSyncResultFactory
         * @param {Array} SA AssessmentSyncResults A list of Assessment Sync Results
         */
		function setAssessmentSyncResultsToStorage(assessmentSyncResults) {
			GenericService.saveAll(assessmentSyncResults,objType,objCallback);
		}

         /**
         * Get Successfull Assessment Sync Results from Local Storage
         * @memberof SaAssessmentSyncResultFactory
         * @param {Array} AssessmentSyncResults A list of Assessment Sync Results
         * @returns {Array} SA AssessmentSyncResults 
         */
		function getSuccesses(syncResults) {
			var result = 0;
			if (!syncResults) {
				return result;
			}
			for (var i = 0; i < syncResults.length; i++) {
				if (syncResults[i].success == true) {
					result = result + 1;
				}
			}

			return result;
		}

    
         /**
         * Get Failed Assessment Sync Results from Local Storage
         * @memberof SaAssessmentSyncResultFactory
         * @param {Array} AssessmentSyncResults A list of Assessment Sync Results
         * @returns {Array} AssessmentSyncResults 
         */
		function getFailures(syncResults) {
			var result = 0;
			if (!syncResults) {
				return result;
			}
			for (var i = 0; i < syncResults.length; i++) {
				if (syncResults[i].success == false) {
					result = result + 1;
				}
			}

			return result;
		}

		return service;
	}
        
})();